import React from "react";
import { useNavigate, useLocation } from "react-router";
import { toast } from "sonner";
import { Post } from "../../config/api/post";
import { AUTH } from "../../config/constants";
import { AuthPage, LoginForm } from "../../components/login-form";

function ForgetPassword2() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (!state?.email) {
      navigate("/forgot-password", { replace: true });
    }
  }, [state, navigate]);

  const onSubmit = (values) => {
    setLoading(true);

    Post(AUTH.verifyCode, { code: values.code, email: state.email })
      .then((response) => {
        setLoading(false);
        if (response?.data?.status) {
          toast.success(response?.data?.message || "Code verified");
          navigate("/forgot-password-3", {
            replace: true,
            state: { code: values.code, email: state.email },
          });
        } else {
          toast.error(
            response?.data?.message || response?.response?.data?.message || "Invalid code"
          );
        }
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e?.data?.message || e?.message || "Internal server error");
      });
  };

  return (
    <AuthPage>
      <LoginForm
        title="Check your email"
        description="Enter the verification code we just sent"
        submitLabel="Verify code"
        loading={loading}
        onSubmit={onSubmit}
        fields={[
          {
            name: "code",
            label: "Verification code",
            type: "text",
            placeholder: "Enter verification code",
            autoComplete: "one-time-code",
          },
        ]}
        footer={
          <button
            type="button"
            className="text-center text-sm font-medium underline-offset-2 hover:underline"
            onClick={() => navigate("/signin")}
          >
            Back to login
          </button>
        }
      />
    </AuthPage>
  );
}

export default ForgetPassword2;
